import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import {
  dropBoolean,
  dropModulo,
  dropIndPag,
  dropModalidade,
} from 'utils/drops';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import InputMask from 'components/InputMask';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'FormaDePagamento';
  const defaultValues = {
    descricao: '',
    modulo: null,
    indpag: null,
    deslocamento: '',
    modalidade: null,
    planocontav_id: null,
    caixa: null,
    fluxo: null,
    ativo: null,
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { drops, getDrops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => {
        navigate(-1);
        getDrops(['FormaDePagamento']);
      },
    });

  return (
    <Container>
      <Header
        titulo={
          (Boolean(state) ? 'Editar' : 'Cadastrar') + ' Forma de Pagamento'
        }
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Input name="descricao" control={control} label="Descrição" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="modulo"
              control={control}
              label="Módulo"
              options={dropModulo}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Dropdown
              name="indpag"
              control={control}
              label="Indicativo de Pagamento"
              options={dropIndPag}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <InputMask
              name="deslocamento"
              control={control}
              label="Deslocamento"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Dropdown
              name="modalidade"
              control={control}
              label="Modalidade"
              options={dropModalidade}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Dropdown
              name="planocontav_id"
              control={control}
              label="Plano de Contas"
              options={drops?.Planoconta?.filter(
                (p) => p?.operacional === 'SIM'
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="caixa"
              control={control}
              label="Caixa"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="fluxo"
              control={control}
              label="Fluxo"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              name="ativo"
              control={control}
              label="Ativo"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
